import { dataStore } from "../constants/dataStore";
import { routePaths } from "../constants/routePaths";

export class UserService {
  // static redirectToSessionExpiry() {
  //   localStorage.removeItem(dataStore.isLoggedIn);
  //   this.logOut(false);
  //   window.location.replace(routePaths.sessionExpiry);
  // }

  static set isLoggedIn(value: string | null) {
    value && localStorage.setItem(dataStore.isLoggedIn, value);
  }

  static get isLoggedIn(): string | null {
    return localStorage.getItem(dataStore.isLoggedIn);
  }

  static set subscriptionId(value: string | null) {
    value && localStorage.setItem(dataStore.subscriptionId, value);
  }

  static get subscriptionId(): string | null {
    return localStorage.getItem(dataStore.subscriptionId);
  }

  static set currentStep(value: string | null) {
    value && sessionStorage.setItem(dataStore.currentStep, value);
  }

  static get currentStep(): string | null {
    return sessionStorage.getItem(dataStore.currentStep);
  }

  static login() {
    this.isLoggedIn = "true";
  }
  static logOut(navigateToLogin: boolean = true) {
    navigateToLogin && window.location.replace(routePaths.login);
    sessionStorage.removeItem(dataStore.currentStep);
    this.isLoggedIn = "false";
  }
}
